import React, { useContext } from "react";
import { AppContext } from "./index";
/*
import Proyectos from "./Datafiles/Proyectos.json";
import Actividades from "./Datafiles/Actividades.json";
import Acciones from "./Datafiles/Acciones.json";
import Riesgos from "./Datafiles/Riesgos.json";
import Cambios from "./Datafiles/Cambios.json";
import Incidentes from "./Datafiles/Incidentes.json";
import LogIncidentes from "./Datafiles/LogIncidentes.json";
import Numeradores from "./Datafiles/Numeradores.json";
import Usuarios from "./Datafiles/Usuarios.json";
import Evaluacion from "./Datafiles/Evaluacion.json";
import Roles from "./Datafiles/Roles.json";
import Categorias from "./Datafiles/Categorias.json";
import Earnvalue from "./Datafiles/Earnvalue.json";

*/
import { Proyecto } from "./contexto/ClasesGrales";
import Stories from "./Datafiles/Stories.json";
import { HOY } from "./general";

export default function Mantenimiento() {
  let { firebase } = useContext(AppContext);

  function altaProyectos(n) {
    for (let x = 1; x < n; x++) {
      let p = new Proyecto();
      p.id = firebase.numProyecto();
      p.nombre = np[x];
      p.pm = usu[x % usu.length];
      p.fechaRegistro = fv[x % fv.length];
      p.estado.alcance = color[x % color.length];
      p.estado.cronograma = color[(x + 1) % color.length];
      p.estado.recursos = color[x % color.length];
      p.estado.semaforo = p.estado.alcance;
      p.prioridad = pr[x % pr.length];
      p.descripcion = texto(10 + x);
      p.fechaEvaluacion = HOY;
      firebase.db.ref("/Proyectos").child(p.id).set(p);
      firebase.nuevaEvaluacion(p.id, HOY);
    }
    return "alta Proyectos finalizada";
  }

  altaProyectos(0)

  return <div>{firebase.altaStories(Stories)}</div>;
}

const np = [
  "Estudio de factibilidad ambiental",
  "Implementación de la fase 2 core",
  "Mejoras en el sistema de compras",
  "Migración de la plataforma web",
  "Definición de la arquitectura madre",
  "Remodelación de centro de cómputos",
  "Implementación de la red digital",
  "Mejoras en sistema de reportes",
  "Actualización tecnológica",
];

const usu = ["PVG", "NVL", "ELE", "NAV"];

const fv = [20200512, 20200531, 20200614, 20200625, 20200709, 20200719, 20200812, 20200811];

const color = ["Rojo", "Amarillo", "Verde"];

const pr = ["Alta", "Media", "Baja"];

function texto(n) {
  const art = [" el ", " la ", " los ", " las ", " un "];
  const accIni = ["Implementar ", "Desarrollar ", "Evaluar ", "Diseñar ", "Elaborar "];
  const obj = [
    "sistema de reconocimiento ",
    "conjunto de funcionalidades que permitan mayor fluidez en el proceso ",
    "pautas de funcionamiento alineadas con las normas de calidad ",
    "procesos de mejora en la cadena de distribución ",
  ];
  const adv = [
    "de forma de mejorar la calidad general del área.",
    "en la medida que el presupuesto del año lo permita.",
    "para estar bien preparados en lo que serán las exigencias del gobierno próximo.",
    "atendiendo del mejor pdo posible lo planteado por la asamblea del mes pasado.",
  ];

  return accIni[n % accIni.length] + art[n % art.length] + obj[n % obj.length] + adv[n % adv.length];
}
